<!-- Folha do documento comercial (§11), usada pela prévia de impressão e pela página pública do link.
     A janela de impressão leva só o conteúdo da `.vfl-papel`. -->
@if (venda) {
  <div class="vfl-previa" #vflPrevia>
    <div class="vfl-papel">
      @if (!isPedido) {
        <!-- ===== Orçamento: modelo único ===== -->
        <table class="vfl-folha">
          <thead>
            <tr>
              <td class="vfl-folha-celula">
                <ng-container *ngTemplateOutlet="tplTopo"></ng-container>
                <h1 class="vfl-titulo">Proposta Comercial Nº {{ numeroDocumento }}</h1>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="vfl-folha-celula">
                <div class="vfl-para">
                  <div>Para</div>
                  <div>{{ nomeCliente }}</div>
                  @if (venda.aosCuidadosDe) {
                    <div>Aos cuidados de: {{ venda.aosCuidadosDe }}</div>
                  }
                </div>

                @if (cliente) {
                  <div class="vfl-cxend">
                    <b>Endereço do Cliente</b>
                    @if (documentoCliente) { <div>{{ documentoCliente | cpfCnpj }}</div> }
                    @if (enderecoClienteLinha1) { <div>{{ enderecoClienteLinha1 }}</div> }
                    @if (enderecoClienteLinha2) { <div>{{ enderecoClienteLinha2 }}</div> }
                    @if (cliente.telefone) { <div>Fone: {{ cliente.telefone | foneMask }}</div> }
                    @if (cliente.email) { <div>E-mail: {{ cliente.email }}</div> }
                  </div>
                }

                @if (venda.introducaoProposta) {
                  <div class="vfl-linha-texto" [innerHTML]="venda.introducaoProposta"></div>
                }
                @if (nomeVendedor) {
                  <div class="vfl-linha-texto">Vendedor(a): {{ nomeVendedor }}</div>
                }
                @if (isImprimirEmailUsuario) {
                  <div class="vfl-linha-texto">Enviado por: {{ dados.emailEnviadoPor }}</div>
                }

                <h2 class="vfl-subtitulo">Itens de produto ou serviço</h2>
                <table class="vfl-tabela">
                  <thead>
                    <tr>
                      <th class="vfl-col-num">Nº</th>
                      <th>Item</th>
                      <th class="vfl-col-sku">SKU</th>
                      <th class="vfl-r vfl-col-qtd">Qtd</th>
                      <th class="vfl-col-un">Un</th>
                      <th class="vfl-r vfl-col-valor">Preço un (R$)</th>
                      <th class="vfl-r vfl-col-valor">Total (R$)</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (bloco of blocos; track $index; let indice = $index) {
                      @if (bloco.item) {
                        <ng-container
                          *ngTemplateOutlet="tplLinhaOrcamento; context: { $implicit: bloco.item, numero: indice + 1 }">
                        </ng-container>
                      } @else {
                        <tr class="vfl-linha vfl-kit">
                          <td>{{ indice + 1 }}</td>
                          <td>Kit: {{ nomeDoKit(bloco) }}</td>
                          <td>{{ skuDoKit(bloco) }}</td>
                          <td class="vfl-r">{{ quantidadeDoKit(bloco) | abnt: 'quantidade' : casasQuantidade }}</td>
                          <td></td>
                          <td class="vfl-r">{{ precoDoKit(bloco) | abnt: 'preco' : casasPreco }}</td>
                          <td class="vfl-r">{{ bloco.totalKit | abnt: 'preco' : 2 }}</td>
                        </tr>
                        @for (componente of bloco.componentes; track componente.sequencia) {
                          <ng-container
                            *ngTemplateOutlet="tplLinhaOrcamento; context: { $implicit: componente, numero: null }">
                          </ng-container>
                        }
                      }
                    }
                  </tbody>
                  <tfoot>
                    <tr class="vfl-totais-inicio">
                      <td colspan="4" class="vfl-res"><b>Número de itens:</b> {{ venda.itens.length }}</td>
                      <td colspan="3"></td>
                    </tr>
                    <tr>
                      <td colspan="4" class="vfl-res">
                        <b>Soma das quantidades:</b> {{ somaQuantidades | abnt: 'quantidade' : casasQuantidade }}
                      </td>
                      <td colspan="2" class="vfl-r vfl-res"><b>Total dos itens</b></td>
                      <td class="vfl-r vfl-res">{{ totalItens | abnt: 'preco' : 2 }}</td>
                    </tr>
                    <ng-container *ngTemplateOutlet="tplAjustesTotal; context: { $implicit: 4, rotulo: 2 }"></ng-container>
                  </tfoot>
                </table>

                <div class="vfl-secao">
                  <table class="vfl-tabela">
                    <thead>
                      <tr>
                        <th class="vfl-col-terco">Data</th>
                        <th class="vfl-c vfl-col-terco">Total dos itens</th>
                        <th class="vfl-r vfl-col-terco">Total da proposta</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ venda.dataEmissao | date: 'dd/MM/yyyy' }}</td>
                        <td class="vfl-c">{{ totalItens | abnt: 'preco' : 2 }}</td>
                        <td class="vfl-r">{{ venda.valorTotal | abnt: 'preco' : 2 }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <ng-container *ngTemplateOutlet="tplPagamento; context: { $implicit: 'Condições comerciais' }"></ng-container>

                @if (venda.validadeDias || nomeFormaEnvio || venda.descricaoCondicoes || venda.dataPrevistaEntrega) {
                  <div class="vfl-secao">
                    <h2 class="vfl-subtitulo">Condições gerais</h2>
                    <table class="vfl-tabela">
                      <tbody>
                        @if (venda.validadeDias) {
                          <tr>
                            <td><b>Validade da proposta</b></td>
                            <td class="vfl-r">
                              {{ venda.validadeDias }} dias
                              @if (venda.dataValidade) { (até {{ venda.dataValidade | date: 'dd/MM/yyyy' }}) }
                            </td>
                          </tr>
                        }
                        @if (venda.dataPrevistaEntrega) {
                          <tr>
                            <td><b>Data prevista de entrega</b></td>
                            <td class="vfl-r">{{ venda.dataPrevistaEntrega | date: 'dd/MM/yyyy' }}</td>
                          </tr>
                        }
                        @if (venda.descricaoCondicoes) {
                          <tr>
                            <td><b>Prazo de entrega</b></td>
                            <td class="vfl-r">{{ venda.descricaoCondicoes }}</td>
                          </tr>
                        }
                        @if (nomeFormaEnvio) {
                          <tr>
                            <td><b>Forma de envio</b></td>
                            <td class="vfl-r">{{ nomeFormaEnvio }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }

                @if (venda.observacoes) {
                  <div class="vfl-secao">
                    <h2 class="vfl-subtitulo">Observações</h2>
                    <div class="vfl-livre" [innerHTML]="venda.observacoes"></div>
                  </div>
                }

                @if (isImprimirSecaoImagens) {
                  <h2 class="vfl-subtitulo">Imagens</h2>
                  @for (item of itensComImagem; track item.sequencia) {
                    <div class="vfl-secao vfl-imagem-secao">
                      <div class="vfl-livre"><b>{{ nomeDoItem(item) }}</b></div>
                      <div class="vfl-imgbox"><img [src]="item.urlImagemCapa" alt="" /></div>
                    </div>
                  }
                }

                <ng-container *ngTemplateOutlet="tplAssinatura"></ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      } @else {
        @switch (layout) {
          @case (layoutEnum.Padrao) {
            <!-- ===== Pedido: padrão ===== -->
            <table class="vfl-folha">
              <thead>
                <tr>
                  <td class="vfl-folha-celula">
                    <ng-container *ngTemplateOutlet="tplCabecalhoPedido"></ng-container>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="vfl-folha-celula">
                    <ng-container *ngTemplateOutlet="tplQuadroPedido"></ng-container>
                    <ng-container *ngTemplateOutlet="tplItensPedido"></ng-container>
                    <ng-container *ngTemplateOutlet="tplPagamento; context: { $implicit: 'Pagamento' }"></ng-container>
                    <ng-container *ngTemplateOutlet="tplTransporte"></ng-container>
                    <ng-container *ngTemplateOutlet="tplObservacoes"></ng-container>
                    <ng-container *ngTemplateOutlet="tplAssinatura"></ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          }
          @case (layoutEnum.Detalhado) {
            <!-- ===== Pedido: detalhado = padrão + imagens + tributos por item + observações internas ===== -->
            <table class="vfl-folha">
              <thead>
                <tr>
                  <td class="vfl-folha-celula">
                    <ng-container *ngTemplateOutlet="tplCabecalhoPedido"></ng-container>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="vfl-folha-celula">
                    <ng-container *ngTemplateOutlet="tplQuadroPedido"></ng-container>
                    <ng-container *ngTemplateOutlet="tplItensPedido"></ng-container>
                    <ng-container *ngTemplateOutlet="tplPagamento; context: { $implicit: 'Pagamento' }"></ng-container>
                    <ng-container *ngTemplateOutlet="tplTransporte"></ng-container>
                    <ng-container *ngTemplateOutlet="tplObservacoes"></ng-container>
                    @if (venda.observacoesInternas) {
                      <div class="vfl-secao">
                        <h2 class="vfl-subtitulo">Observações internas</h2>
                        <div class="vfl-livre" [innerHTML]="venda.observacoesInternas"></div>
                      </div>
                    }
                    <ng-container *ngTemplateOutlet="tplAssinatura"></ng-container>
                  </td>
                </tr>
              </tbody>
            </table>
          }
          @case (layoutEnum.Recibo) {
            <!-- ===== Pedido: recibo — folha compacta, sem logo, quadros, tributos, observações e assinatura ===== -->
            <table class="vfl-folha vfl-folha-recibo">
              <thead>
                <tr>
                  <td class="vfl-folha-celula">
                    <div class="vfl-emit-recibo">
                      <b>{{ nomeEmitente }}</b>
                      @if (cnpjEmpresa) { <div>CNPJ {{ cnpjEmpresa }}</div> }
                      @if (isImprimirEnderecoEmpresa && enderecoEmpresaLinhaUnica) {
                        <div>{{ enderecoEmpresaLinhaUnica }}</div>
                      }
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="vfl-folha-celula">
                    <table class="vfl-tabela vfl-recibo-itens">
                      <thead>
                        <tr>
                          <th class="vfl-col-cod">Cod</th>
                          <th>Descrição</th>
                          <th class="vfl-r vfl-col-recibo">Qtd Un</th>
                          <th class="vfl-r vfl-col-recibo">VL UN (R$)</th>
                          <th class="vfl-r vfl-col-recibo">Total (R$)</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (bloco of blocos; track $index) {
                          @if (bloco.item) {
                            <ng-container *ngTemplateOutlet="tplLinhaRecibo; context: { $implicit: bloco.item, componente: false }">
                            </ng-container>
                          } @else {
                            <tr class="vfl-linha-recibo vfl-kit">
                              <td>{{ skuDoKit(bloco) }}</td>
                              <td>Kit: {{ nomeDoKit(bloco) }}</td>
                              <td class="vfl-r">{{ quantidadeDoKit(bloco) | abnt: 'quantidade' : casasQuantidade }}</td>
                              <td class="vfl-r">{{ precoDoKit(bloco) | abnt: 'preco' : casasPreco }}</td>
                              <td class="vfl-r">{{ bloco.totalKit | abnt: 'preco' : 2 }}</td>
                            </tr>
                            @for (componente of bloco.componentes; track componente.sequencia) {
                              <ng-container *ngTemplateOutlet="tplLinhaRecibo; context: { $implicit: componente, componente: true }">
                              </ng-container>
                            }
                          }
                        }
                      </tbody>
                    </table>

                    <div class="vfl-secao">
                      <table class="vfl-tabela vfl-recibo-totais">
                        <tbody>
                          <tr><td>Qtde. total de itens</td><td class="vfl-r">{{ venda.itens.length }}</td></tr>
                          <tr><td>Valor total</td><td class="vfl-r">{{ totalItens | abnt: 'preco' : 2 }}</td></tr>
                          <tr><td>Desconto</td><td class="vfl-r">{{ venda.valorDesconto || 0 | abnt: 'preco' : 2 }}</td></tr>
                          <tr><td>Acréscimos</td><td class="vfl-r">{{ acrescimos | abnt: 'preco' : 2 }}</td></tr>
                          <tr class="vfl-forte"><td>Valor a pagar</td><td class="vfl-r">{{ venda.valorTotal | abnt: 'preco' : 2 }}</td></tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="vfl-secao">
                      <table class="vfl-tabela vfl-recibo-pagamento">
                        <thead>
                          <tr>
                            <th>FORMA DE PAGAMENTO</th>
                            <th class="vfl-c">VENCIMENTO</th>
                            <th class="vfl-r">VALOR PAGO R$</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (pagamento of pagamentos; track pagamento.sequencia) {
                            @for (parcela of pagamento.parcelas; track parcela.numeroParcela) {
                              <tr>
                                <td>{{ nomeFormaRecebimento(pagamento.idFormaRecebimento) }}</td>
                                <td class="vfl-c">{{ parcela.dataVencimento | date: 'dd/MM/yyyy' }}</td>
                                <td class="vfl-r">{{ parcela.valor | abnt: 'preco' : 2 }}</td>
                              </tr>
                            } @empty {
                              <tr>
                                <td>{{ nomeFormaRecebimento(pagamento.idFormaRecebimento) }}</td>
                                <td class="vfl-c">–</td>
                                <td class="vfl-r">{{ pagamento.valor || 0 | abnt: 'preco' : 2 }}</td>
                              </tr>
                            }
                          }
                        </tbody>
                      </table>
                    </div>

                    @if (nomeCliente) {
                      <div class="vfl-secao vfl-consumidor">
                        <b>Consumidor:</b>
                        <div class="vfl-consumidor-dados">
                          {{ nomeCliente }}
                          @if (documentoCliente) { {{ rotuloDocumentoCliente }} - {{ documentoCliente | cpfCnpj }} }
                          @if (enderecoConsumidor) { - {{ enderecoConsumidor }} }
                        </div>
                      </div>
                    }

                    <div class="vfl-venda-rodape">
                      Venda nº {{ numeroDocumento }} {{ venda.datetimeInclusao | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          }
        }
      }
    </div>
  </div>
}

<!-- ================= Sub-blocos da folha ================= -->

<!-- Logo e emitente (Orçamento, Pedido padrão e detalhado). -->
<ng-template #tplTopo>
  <div class="vfl-topo">
    @if (logoUrl) {
      <img class="vfl-logo" [src]="logoUrl" alt="" />
    } @else {
      <span></span>
    }
    <div class="vfl-emit">
      <b>{{ nomeEmitente }}</b>
      @if (cnpjEmpresa) { <div>{{ cnpjEmpresa }}</div> }
      @if (isImprimirEnderecoEmpresa) {
        @for (linha of linhasEnderecoEmpresa; track $index) { <div>{{ linha }}</div> }
      }
      @if (inscricaoEstadualEmpresa) { <div>{{ inscricaoEstadualEmpresa }}</div> }
    </div>
  </div>
</ng-template>

<!-- Cabeçalho repetido do Pedido: emitente, título e código de barras. -->
<ng-template #tplCabecalhoPedido>
  <ng-container *ngTemplateOutlet="tplTopo"></ng-container>
  <h1 class="vfl-titulo">Pedido de Venda Nº {{ numeroDocumento }}</h1>
  @if (isImprimirCodigoBarras) {
    <div class="vfl-barcode"><svg #vflCodigoBarras></svg></div>
  }
</ng-template>

<!-- Quadro do cliente ao lado do quadro do documento (§11.4). -->
<ng-template #tplQuadroPedido>
  @if (venda) {
    <div class="vfl-secao vfl-quadros">
      <table class="vfl-tabela vfl-dados vfl-quadro-cliente">
        <tbody>
          <tr>
            <td class="vfl-rot">Cliente</td>
            <td>
              {{ nomeCliente }}
              @if (cliente?.nomeFantasia) { <div class="vfl-sub">{{ cliente?.nomeFantasia }}</div> }
              @if (documentoCliente) { <div class="vfl-sub">{{ documentoCliente | cpfCnpj }}</div> }
            </td>
          </tr>
          <tr>
            <td class="vfl-rot">Endereço</td>
            <td>
              @if (enderecoClienteLinha1) { <div>{{ enderecoClienteLinha1 }}</div> }
              @if (enderecoClienteLinha2) { <div>{{ enderecoClienteLinha2 }}</div> }
            </td>
          </tr>
          <tr>
            <td class="vfl-rot">Contato</td>
            <td>
              @if (cliente?.email) { <div>{{ cliente?.email }}</div> }
              @if (cliente?.telefone) { <div>{{ cliente?.telefone | foneMask }}</div> }
            </td>
          </tr>
          <tr>
            <td class="vfl-rot">Vendedor(a)</td>
            <td>{{ nomeVendedor }}</td>
          </tr>
        </tbody>
      </table>
      <table class="vfl-tabela vfl-dados vfl-quadro-documento">
        <tbody>
          <tr><td class="vfl-rot">Número do pedido</td><td>{{ numeroDocumento }}</td></tr>
          <tr><td class="vfl-rot">Situação</td><td>{{ dados.nomeEtapa }}</td></tr>
          <tr><td class="vfl-rot">Data</td><td>{{ venda.dataEmissao | date: 'dd/MM/yyyy' }}</td></tr>
          <tr><td class="vfl-rot">Data prevista</td><td>{{ venda.dataPrevistaEntrega | date: 'dd/MM/yyyy' }}</td></tr>
        </tbody>
      </table>
    </div>
  }
</ng-template>

<!-- Grade de itens do Pedido (padrão e detalhado) com o rodapé de totais. -->
<ng-template #tplItensPedido>
  @if (venda) {
    <h2 class="vfl-subtitulo">Itens</h2>
    <table class="vfl-tabela">
      <thead>
        <tr>
          <th>Item</th>
          <th class="vfl-col-codigo">Código (SKU) / GTIN / NCM</th>
          <th class="vfl-r vfl-col-qtd">Qtd</th>
          <th class="vfl-col-un">Un</th>
          <th class="vfl-r vfl-col-valor">Preço un (R$)</th>
          <th class="vfl-r vfl-col-valor">Total (R$)</th>
        </tr>
      </thead>
      <tbody>
        @for (bloco of blocos; track $index) {
          @if (bloco.item) {
            <ng-container *ngTemplateOutlet="tplLinhaPedido; context: { $implicit: bloco.item, componente: false }"></ng-container>
          } @else {
            <tr class="vfl-linha vfl-kit">
              <td>Kit: {{ nomeDoKit(bloco) }}</td>
              <td>{{ skuDoKit(bloco) }}</td>
              <td class="vfl-r">{{ quantidadeDoKit(bloco) | abnt: 'quantidade' : casasQuantidade }}</td>
              <td></td>
              <td class="vfl-r">{{ precoDoKit(bloco) | abnt: 'preco' : casasPreco }}</td>
              <td class="vfl-r">{{ bloco.totalKit | abnt: 'preco' : 2 }}</td>
            </tr>
            @for (componente of bloco.componentes; track componente.sequencia) {
              <ng-container *ngTemplateOutlet="tplLinhaPedido; context: { $implicit: componente, componente: true }"></ng-container>
            }
          }
        }
      </tbody>
      <tfoot>
        <tr class="vfl-totais-inicio">
          <td colspan="4" class="vfl-res"><b>Número de itens:</b> {{ venda.itens.length }}</td>
          <td class="vfl-r vfl-res"><b>Total de produtos</b></td>
          <td class="vfl-r vfl-res">{{ totalItens | abnt: 'preco' : 2 }}</td>
        </tr>
        <tr>
          <td colspan="4" class="vfl-res"><b>Soma das quantidades:</b> {{ somaQuantidades | abnt: 'quantidade' : casasQuantidade }}</td>
          <td colspan="2"></td>
        </tr>
        <ng-container *ngTemplateOutlet="tplAjustesTotal; context: { $implicit: 4, rotulo: 1 }"></ng-container>
      </tfoot>
    </table>
  }
</ng-template>

<!-- Desconto, frete e despesas só quando diferentes de zero; depois o total do documento.
     $implicit = colunas vazias à esquerda; rotulo = colunas do rótulo. -->
<ng-template #tplAjustesTotal let-vazias let-rotulo="rotulo">
  @if (venda) {
    @if (venda.valorDesconto) {
      <tr>
        <td [attr.colspan]="vazias"></td>
        <td [attr.colspan]="rotulo" class="vfl-r vfl-res"><b>Desconto</b></td>
        <td class="vfl-r vfl-res">{{ venda.valorDesconto | abnt: 'preco' : 2 }}</td>
      </tr>
    }
    @if (venda.valorFrete) {
      <tr>
        <td [attr.colspan]="vazias"></td>
        <td [attr.colspan]="rotulo" class="vfl-r vfl-res"><b>Frete</b></td>
        <td class="vfl-r vfl-res">{{ venda.valorFrete | abnt: 'preco' : 2 }}</td>
      </tr>
    }
    @if (venda.valorDespesas) {
      <tr>
        <td [attr.colspan]="vazias"></td>
        <td [attr.colspan]="rotulo" class="vfl-r vfl-res"><b>Despesas</b></td>
        <td class="vfl-r vfl-res">{{ venda.valorDespesas | abnt: 'preco' : 2 }}</td>
      </tr>
    }
    @if (isPedido) {
      <tr>
        <td [attr.colspan]="vazias"></td>
        <td [attr.colspan]="rotulo" class="vfl-r vfl-res"><b>Total do pedido</b></td>
        <td class="vfl-r vfl-res">{{ venda.valorTotal | abnt: 'preco' : 2 }}</td>
      </tr>
    }
  }
</ng-template>

<!-- Linha de item do Pedido; componente de kit entra recuado. -->
<ng-template #tplLinhaPedido let-item let-componente="componente">
  <tr class="vfl-linha" [class.vfl-componente]="componente">
    <td><ng-container *ngTemplateOutlet="tplDescricaoItem; context: { $implicit: item }"></ng-container></td>
    <td>
      {{ item.codigoSku }}
      @if (item.gtinEan) { <div class="vfl-sub">GTIN: {{ item.gtinEan }}</div> }
      @if (item.codigoNcm) { <div class="vfl-sub">NCM: {{ item.codigoNcm }}</div> }
    </td>
    <td class="vfl-r">{{ item.quantidade | abnt: 'quantidade' : casasQuantidade }}</td>
    <td>{{ item.siglaUnidade }}</td>
    <td class="vfl-r">{{ item.precoLiquidoUnitario | abnt: 'preco' : casasPreco }}</td>
    <td class="vfl-r">{{ item.valorTotal | abnt: 'preco' : 2 }}</td>
  </tr>
</ng-template>

<!-- Linha de item do Orçamento; componente de kit entra recuado e sem número. -->
<ng-template #tplLinhaOrcamento let-item let-numero="numero">
  <tr class="vfl-linha" [class.vfl-componente]="numero === null">
    <td>{{ numero }}</td>
    <td><ng-container *ngTemplateOutlet="tplDescricaoItem; context: { $implicit: item }"></ng-container></td>
    <td>
      {{ item.codigoSku }}
      @if (isImprimirNcm && item.codigoNcm) { <div class="vfl-sub">NCM: {{ item.codigoNcm }}</div> }
    </td>
    <td class="vfl-r">{{ item.quantidade | abnt: 'quantidade' : casasQuantidade }}</td>
    <td>{{ item.siglaUnidade }}</td>
    <td class="vfl-r">{{ item.precoLiquidoUnitario | abnt: 'preco' : casasPreco }}</td>
    <td class="vfl-r">{{ item.valorTotal | abnt: 'preco' : 2 }}</td>
  </tr>
</ng-template>

<!-- Linha de item do Recibo. -->
<ng-template #tplLinhaRecibo let-item let-componente="componente">
  <tr class="vfl-linha-recibo" [class.vfl-componente]="componente">
    <td>{{ item.codigoSku }}</td>
    <td>{{ nomeDoItem(item) }}</td>
    <td class="vfl-r">{{ item.quantidade | abnt: 'quantidade' : casasQuantidade }} {{ item.siglaUnidade }}</td>
    <td class="vfl-r">{{ item.precoLiquidoUnitario | abnt: 'preco' : casasPreco }}</td>
    <td class="vfl-r">{{ item.valorTotal | abnt: 'preco' : 2 }}</td>
  </tr>
</ng-template>

<!-- Nome do item com imagem de capa, descrição complementar e tributos, conforme as configurações. -->
<ng-template #tplDescricaoItem let-item>
  <div class="vfl-item-descricao">
    @if (isImprimirImagemNoItem && item.urlImagemCapa) {
      <img class="vfl-img-item" [src]="item.urlImagemCapa" alt="" />
    }
    <div>
      {{ nomeDoItem(item) }}
      @if (isImprimirDescComplementar && item.descricaoComplementar) {
        <div class="vfl-sub">{{ item.descricaoComplementar }}</div>
      }
      @if (isImprimirImpostos) {
        <div class="vfl-trib">
          @for (imposto of impostosDoItem(item); track imposto.rotulo; let ultimo = $last) {
            <span class="vfl-trib-rotulo">{{ imposto.rotulo }}:</span> {{ imposto.valor }}@if (!ultimo) { | }
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- Recebimentos (forma, condição, intermediador, bandeira) e a grade de parcelas. -->
<ng-template #tplPagamento let-titulo>
  @if (venda && (pagamentos.length > 0 || venda.condicoesComerciais)) {
    <div class="vfl-secao">
      <h2 class="vfl-subtitulo">{{ titulo }}</h2>
      @if (pagamentos.length > 0) {
        <table class="vfl-tabela">
          <thead>
            <tr>
              <th>Forma de pagamento</th>
              <th>Condição</th>
              @if (temIntermediador) { <th>Intermediador</th> }
              @if (temBandeira) { <th>Bandeira</th> }
              <th class="vfl-r vfl-col-valor">Valor (R$)</th>
            </tr>
          </thead>
          <tbody>
            @for (pagamento of pagamentos; track pagamento.sequencia) {
              <tr class="vfl-linha">
                <td>{{ nomeFormaRecebimento(pagamento.idFormaRecebimento) }}</td>
                <td>{{ nomeCondicao(pagamento) }}</td>
                @if (temIntermediador) { <td>{{ nomeIntermediador(pagamento) }}</td> }
                @if (temBandeira) { <td>{{ nomeBandeira(pagamento) }}</td> }
                <td class="vfl-r">{{ pagamento.valor || 0 | abnt: 'preco' : 2 }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (temParcelas) {
        <table class="vfl-tabela vfl-parcelas">
          <thead>
            <tr>
              <th class="vfl-col-dias">Dias</th>
              <th class="vfl-col-data">Data vencimento</th>
              <th>Forma de pagamento</th>
              <th class="vfl-r vfl-col-valor">Valor (R$)</th>
              <th>Observação</th>
            </tr>
          </thead>
          <tbody>
            @for (pagamento of pagamentos; track pagamento.sequencia) {
              @for (parcela of pagamento.parcelas; track parcela.numeroParcela) {
                <tr class="vfl-linha">
                  <td>{{ parcela.dias }}</td>
                  <td>{{ parcela.dataVencimento | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ nomeFormaRecebimento(pagamento.idFormaRecebimento) }}</td>
                  <td class="vfl-r">{{ parcela.valor | abnt: 'preco' : 2 }}</td>
                  <td>{{ parcela.observacao }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      }
      @if (venda.condicoesComerciais) {
        <div class="vfl-livre vfl-texto-livre">{{ venda.condicoesComerciais }}</div>
      }
    </div>
  }
</ng-template>

<!-- Faixa de transporte e pesos do Pedido (peso por unidade × quantidade). -->
<ng-template #tplTransporte>
  @if (venda) {
    <div class="vfl-secao">
      <h2 class="vfl-subtitulo">Transporte</h2>
      <table class="vfl-tabela vfl-pares">
        <tbody>
          @if (nomeFormaEnvio || venda.nomePessoaTransportador) {
            <tr class="vfl-linha">
              <td class="vfl-rot">Forma de envio</td>
              <td>{{ nomeFormaEnvio }}</td>
              <td class="vfl-rot">Transportador</td>
              <td>{{ venda.nomePessoaTransportador }}</td>
            </tr>
          }
          <tr class="vfl-linha">
            <td class="vfl-rot">Peso bruto</td>
            <td>{{ pesoBruto | abnt: 'quantidade' : 3 }}</td>
            <td class="vfl-rot">Peso líquido</td>
            <td>{{ pesoLiquido | abnt: 'quantidade' : 3 }}</td>
          </tr>
          @if (venda.volumes) {
            <tr class="vfl-linha">
              <td class="vfl-rot">Volumes</td>
              <td colspan="3">{{ venda.volumes }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</ng-template>

<!-- Caixa de Observações do Pedido (sai mesmo vazia, para anotação à mão). -->
<ng-template #tplObservacoes>
  @if (venda) {
    <div class="vfl-secao">
      <h2 class="vfl-subtitulo">Observações</h2>
      <div class="vfl-livre" [innerHTML]="venda.observacoes || ''"></div>
    </div>
  }
</ng-template>

<!-- Saudação e responsável do documento; no Pedido, as linhas de recebimento conforme a configuração. -->
<ng-template #tplAssinatura>
  @if (venda && (venda.assinaturaSaudacao || venda.assinaturaResponsavel || isImprimirCamposAssinatura)) {
    <div class="vfl-secao vfl-assin">
      @if (venda.assinaturaSaudacao) { <div>{{ venda.assinaturaSaudacao }}</div> }
      @if (venda.assinaturaResponsavel) { <div>{{ venda.assinaturaResponsavel }}</div> }
      @if (isImprimirCamposAssinatura) {
        <div class="vfl-campos-assinatura">
          <div>Data de Recebimento: ____/____/________</div>
          <div>Assinatura do Recebedor: ______________________________________</div>
        </div>
      }
    </div>
  }
</ng-template>
